module.exports = __webpack_public_path__ + "img/Foto_Press_Release_KasPro_x_Okejek.f97e5cac.jpeg";